import { render, staticRenderFns } from "./RegisterRiderSend.vue?vue&type=template&id=5952c8af&scoped=true"
import script from "./RegisterRiderSend.vue?vue&type=script&lang=js"
export * from "./RegisterRiderSend.vue?vue&type=script&lang=js"
import style0 from "./RegisterRiderSend.vue?vue&type=style&index=0&id=5952c8af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952c8af",
  null
  
)

export default component.exports